import { render, staticRenderFns } from "./honorModule.vue?vue&type=template&id=056b498c&scoped=true"
import script from "./honorModule.vue?vue&type=script&lang=js"
export * from "./honorModule.vue?vue&type=script&lang=js"
import style0 from "./honorModule.vue?vue&type=style&index=0&id=056b498c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056b498c",
  null
  
)

export default component.exports